import React, { useCallback } from 'react';
import type { UserOption } from '@atlassian/jira-base-user-picker';
import { performGetRequest } from '@atlassian/jira-fetch';
import UserPickerField from '../../common/ui/fields/base-fields/user-picker-field';
import type { PeopleFieldProps } from './types';
import { transformToUserOption } from './utils';

const PeopleField = (props: PeopleFieldProps) => {
	const {
		additionalData: { isMulti },
		autoCompleteUrl,
		selectedProject,
		...rest
	} = props;

	const projectKey = selectedProject?.projectKey;

	const fetchSuggestions = useCallback(
		async (query: string | null): Promise<UserOption[]> => {
			const autoCompleteResponse = await performGetRequest(
				`/rest/api/3/user/recommend?${new URLSearchParams({
					context: 'People',
					...(projectKey && { project: projectKey }),
					query: query ?? '',
				})}`,
			);

			return (autoCompleteResponse ?? []).map(transformToUserOption);
		},
		[projectKey],
	);

	return (
		<UserPickerField
			{...rest}
			isMulti={isMulti}
			autoCompleteUrl={autoCompleteUrl}
			onFetchSuggestions={fetchSuggestions}
		/>
	);
};

export default PeopleField;
export { mutatePeopleField, mapUserOptionOrOptionsToIds } from './utils';
